// Extraído de VideoUploadPage — subida de un track de audio (ver
// openspec/changes/video-multi-audio-tracks) reusa el mismo patrón de
// progreso/cancelación que ya tenía la subida del video principal.
export function uploadFileWithProgress(
  url: string,
  headers: Record<string, string> | undefined,
  file: File,
  onProgress: (percent: number) => void,
  xhrRef: { current: XMLHttpRequest | null },
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhrRef.current = xhr
    xhr.open("PUT", url)
    for (const [key, value] of Object.entries(headers ?? {})) {
      xhr.setRequestHeader(key, value)
    }
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        onProgress(Math.round((event.loaded / event.total) * 100))
      }
    }
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve()
      } else {
        reject(new Error(`R2 upload failed: ${xhr.status}`))
      }
    }
    xhr.onerror = () => reject(new Error("R2 upload failed: network error"))
    xhr.onabort = () => reject(new Error("R2 upload failed: aborted"))
    xhr.send(file)
  })
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
